module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwMSIgdmlld0JveD0iMCAwIDMwMSAyMDEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA3QTVFIiBkPSJNLjUuNWgxMDB2MjAwSC41eiIvPjxwYXRoIGZpbGw9IiNDRTExMjYiIGQ9Ik0xMDAuNS41aDEwMHYyMDBoLTEwMHoiLz48cGF0aCBmaWxsPSIjRkNEMTE2IiBkPSJNMjAwLjUuNWgxMDB2MjAwaC0xMDB6TTEyNS4xMzggOTIuMjZsMTUuNjc1IDExLjM4OC01Ljk4NyAxOC40MjYgMTUuNjc0LTExLjM4OCAxNS42NzQgMTEuMzg4LTUuOTg3LTE4LjQyNiAxNS42NzUtMTEuMzg4SDE1Ni40bC01LjktMTguNDI3LTUuODk5IDE4LjQyN3oiLz48L2c+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-cm.svg
// module id = tlAO
// module chunks = 2